/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_RentSourceBulkDataSubscriptionAttributes_ } from '../models/ControllerResponse_RentSourceBulkDataSubscriptionAttributes_';
import type { ControllerResponse_RentSourceBulkDataSubscriptionAttributes_Array_ } from '../models/ControllerResponse_RentSourceBulkDataSubscriptionAttributes_Array_';
import type { ControllerResponse_RentSourceBulkDataSubscriptionAttributes_or_null_ } from '../models/ControllerResponse_RentSourceBulkDataSubscriptionAttributes_or_null_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BulkDataService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_RentSourceBulkDataSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public list(): CancelablePromise<ControllerResponse_RentSourceBulkDataSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data/list',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_RentSourceBulkDataSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public get(
        id: number,
    ): CancelablePromise<ControllerResponse_RentSourceBulkDataSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns ControllerResponse_RentSourceBulkDataSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public update(
        id: number,
        requestBody: {
            schedule: Array<string>;
            emails_enabled: boolean;
            emails: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_RentSourceBulkDataSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/bulk_data',
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public sendEmail(
        id: number,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data/send_email',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param msa
     * @param minUnits
     * @param maxUnits
     * @param minYearBuilt
     * @param maxYearBuilt
     * @param isMultiFamily
     * @param isSingleFamily
     * @param isCondo
     * @param isApartment
     * @param isSenior
     * @param isStudent
     * @param isAffordable
     * @returns any Ok
     * @throws ApiError
     */
    public export(
        msa: string,
        minUnits?: number,
        maxUnits?: number,
        minYearBuilt?: number,
        maxYearBuilt?: number,
        isMultiFamily?: boolean,
        isSingleFamily?: boolean,
        isCondo?: boolean,
        isApartment?: boolean,
        isSenior?: boolean,
        isStudent?: boolean,
        isAffordable?: boolean,
    ): CancelablePromise<{
        expires: string;
        url: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data/export',
            query: {
                'msa': msa,
                'min_units': minUnits,
                'max_units': maxUnits,
                'min_year_built': minYearBuilt,
                'max_year_built': maxYearBuilt,
                'is_multi_family': isMultiFamily,
                'is_single_family': isSingleFamily,
                'is_condo': isCondo,
                'is_apartment': isApartment,
                'is_senior': isSenior,
                'is_student': isStudent,
                'is_affordable': isAffordable,
            },
        });
    }
}
